<template>
  <div>
    <b-card
no-body
class="mb-0"
>
      <div class="m-2">
        <b-row>
          <!-- Per Page -->
         <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <label>Show</label>
                <v-select
    v-model="perPage"
    :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
                />
                <label>entries</label>
              </b-col>

          <!-- Search -->
          <b-col
cols="12"
md="6"
>
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
            </div>
          </b-col>
        </b-row>
      </div>

      <!-- TABLE -->
      <b-table
        ref="refReturnListTable"
        class="position-relative"
        :items="fetchReturns"
        :fields="tableColumns"
        responsive
        primary-key="id"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDirDesc"
        show-empty
        empty-text="No matching records found"
        :busy="loading"
      >
        <template #table-busy>
          <b-skeleton-table
            :rows="perPage || 5"
            :columns="tableColumns ? tableColumns.length : 6"
            :table-props="{ bordered: true, striped: true }"
          />
        </template>

        <!-- PO Number -->
        <template #cell(po_number)="data">
          <span>
            {{
              data.item.purchase_order
                ? data.item.purchase_order.purchase_order_number
                : '-'
            }}
          </span>
        </template>

        <!-- Surat Jalan -->
        <template #cell(return_no_surat_jalan)="data">
          <span>{{ data.item.return_no_surat_jalan }}</span>
        </template>

        <!-- Date -->
        <template #cell(date_created)="data">
          {{ dateSimple(data.item.return_created_time, 'YYYY-MM-DD HH:mm:ss') }}
        </template>

        <!-- Action -->
        <template #cell(Action)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item @click="showDetail(data.item)">
              <feather-icon icon="ZoomInIcon" />
              <span class="ml-50">Detail</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <!-- FOOTER -->
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">
              Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
              {{ dataMeta.of }} entries
            </span>
          </b-col>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalReturnes || (currentPage * perPage)"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
            >
              <template #prev-text>
                <feather-icon
icon="ChevronLeftIcon"
size="18"
/>
              </template>
              <template #next-text>
                <feather-icon
icon="ChevronRightIcon"
size="18"
/>
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { onMounted, onUnmounted } from '@vue/composition-api'
import moment from 'moment-timezone'
import store from '@/store'
import listPagePersistence from '@/mixins/listPagePersistence'
import ReturnList from './List'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  mixins: [listPagePersistence(['currentPage'])],

  setup(_, { root }) {
    // ───── TABLE COMPOSABLE ─────
    const {
      fetchReturns,
      loading,
      tableColumns,
      perPage,
      currentPage,
      totalReturnes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refReturnListTable,
    } = ReturnList()

    // ───── HELPERS ─────
    const dateSimple = (value, format = 'YYYY-MM-DD') => {
      if (!value) return null
      return moment.utc(value).tz('Asia/Jakarta').format(format)
    }

    const showDetail = item => {
      localStorage.setItem("ReturnDetail", JSON.stringify(item))
      root.$router.push({ name: 'apps-returns-details' })
    }

    const refreshHandler = () => {
      if (refReturnListTable.value) {
        refReturnListTable.value.refresh()
      }
    }

    // ───── LIFECYCLE ─────
    onMounted(() => {
      root.$on('refreshTable', refreshHandler)
    })

    onUnmounted(() => {
      root.$off('refreshTable', refreshHandler)

      if (store.hasModule('app-return')) {
        store.unregisterModule('app-return')
      }
    })

    return {
      fetchReturns,
      loading,
      tableColumns,
      perPage,
      currentPage,
      totalReturnes,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refReturnListTable,

      dateSimple,
      showDetail,
    }
  },
}
</script>

<style scoped>
.per-page-selector {
  width: 90px;
}
</style>
